import { AxiosError } from 'axios'

interface ErrorMessage {
  status: string
  status_type: string
  message: string
}

interface ApiErrorResponse {
  status?: string
  status_type?: string
  message?: string
  errors?: Record<string, string[]>
}

export const getErrorMessage = (data: unknown): string | undefined => {
  const error = data as AxiosError<ErrorMessage>

  if (error?.response?.data) {
    return error?.response?.data?.message
  }

  return undefined
}

export const getErrorUrl = (data: unknown): string | undefined => {
  const error = data as AxiosError<ErrorMessage>

  return error?.config?.url
}

export const getApiErrorMessage = (
  error: unknown,
  defaultMessage = 'Ошибка при загрузке данных',
): string | null => {
  if (error instanceof AxiosError) {
    if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError') {
      return null
    }

    const errorData = error.response?.data as ApiErrorResponse | undefined

    if (errorData) {
      let errorMessage = errorData.message || defaultMessage

      if (errorData.errors) {
        const validationErrors = Object.entries(errorData.errors)
          .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
          .join('; ')

        if (validationErrors) {
          errorMessage = `${errorMessage}. ${validationErrors}`
        }
      }

      return errorMessage
    }

    return error.message || defaultMessage
  }

  if (error instanceof Error) {
    return error.message
  }

  return defaultMessage
}
